import { Instance } from 'mobx-state-tree';
import { DriverAddedDtoModelBase } from './DriverAddedDtoModel.base';

/* The TypeScript type of an instance of DriverAddedDtoModel */
export interface DriverAddedDtoModelType extends Instance<typeof DriverAddedDtoModel.Type> {}

/* A graphql query fragment builders for DriverAddedDtoModel */
export { selectFromDriverAddedDto, driverAddedDtoModelPrimitives, DriverAddedDtoModelSelector } from './DriverAddedDtoModel.base';

/**
 * DriverAddedDtoModel
 */
export const DriverAddedDtoModel = DriverAddedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
